import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Box } from 'grommet';
import { FormNext } from 'grommet-icons';
import NoAuthLayout, {
  StyledSubmissionInput, StyledSubmissionField, StyledSubmissionAnchor,
} from '@Components/Layout/NoAuth';
import { useAppTheme } from '@Components/Context';
import { AppButton } from '@Components/Control';
import { paths } from '@Components/configs';
import { adminLogInRequest } from '@Actions';

const AdminLogin = ({
  small,
  logIn,
}) => {
  const { theme: { button, page } } = useAppTheme();

  const handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = e.value;
    logIn(email, password);
  };

  return (
    <NoAuthLayout
      seoConfig={null}
      title="Admin"
      small={small}
    >
      <Form onSubmit={handleSubmit}>
        <StyledSubmissionField required name="email" htmlFor="email" type="email">
          <StyledSubmissionInput
            plain
            name="email"
            type="email"
            placeholder="Email"
          />
        </StyledSubmissionField>
        <StyledSubmissionField required name="password" htmlFor="password" type="password">
          <StyledSubmissionInput
            plain
            name="password"
            type="password"
            placeholder="Password"
          />
        </StyledSubmissionField>
        <AppButton
          overrideHover
          type="submit"
          level="authSubmit"
          bgColor={button.primaryBg}
          color={button.primaryText}
          label="Sign In"
          alignSelf="center"
        />
        <Box width="100%" pad={{ top: '1.5rem' }} align="center" justify="center">
          <Box direction="row" gap="0.25rem" align="center" justify="start">
            <FormNext size="0.75rem" color={page.altHighlight} style={{ paddingTop: '1px' }} />
            <StyledSubmissionAnchor
              label="Non-admin user sign in"
              path={paths.login}
              color={page.primaryText}
              hoverColor={page.altHighlight}
            />
          </Box>
        </Box>
      </Form>
    </NoAuthLayout>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logIn: adminLogInRequest }, dispatch);
}

AdminLogin.propTypes = {
  small: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(AdminLogin);
